import getLocalizationLink from 'utils/getLocalizationLink';

const tempLink = '';
const TRADE_URL = `${process.env.WEB_APP_HOST}`;
const ZENDESK_GLOBAL = 'https://qryptos.zendesk.com/hc/en-us';

export const liquid = 'https://www.liquid.com/';
export const ftxSignUp = 'https://ftx.com/onboarding/signup?utm_campaign=migrate&utm_medium=banner&utm_source=liquid';
// export const LENDING_URL = `${process.env.WEB_APP_HOST}/lend/market`;
export const SIGN_IN_LINK = `${process.env.WEB_APP_HOST}/sign-in`;
export const SIGN_UP_LINK = `${process.env.WEB_APP_HOST}/sign-up`;
export const REFERRALS_LINK = `${process.env.WEB_APP_HOST}/settings/referral`;
export const INTERCOM_LINK = 'https://help.liquid.com';
export const LIQUID_BUY_SUPPORT =
  'https://help.liquid.com/en/articles/4141955-liquid-buy-faq';

export const GOOGLE_PLAY_APP_LINK =
  'https://play.google.com/store/apps/details?id=com.quoine.liquid';
export const APPLE_STORE_APP_LINK =
  'https://itunes.apple.com/us/app/liquid-pro/id1443975079?mt=8';

export const subscribeForm = () => ({
  userPolicy:
    'https://quoine-prod.s3.amazonaws.com/uploads/policy_document/term_document/97/Liquid_Terms_of_Use__Global__v1.14__Final_2018.09.04_.pdf',
  privacyPolicy:
    'https://quoine-prod.s3.amazonaws.com/uploads/policy_document/term_document/96/Liquid_Privacy_Policy_and_Cookies_Policy__Global__v1.02__Final_2018.09.04_.pdf',
  tradingPolicy:
    'https://quoine-prod.s3.amazonaws.com/uploads/policy_document/term_document/95/Liquid_Trading_Rules__Global__v1.09__Final_2018.09.04_.pdf',
  riskDisclosure:
    'https://quoine-prod.s3.amazonaws.com/uploads/policy_document/term_document/98/Liquid_Risk_Disclosure_Statement__Global__v1.05__Final_2018.09.04_.pdf',
});

/* eslint-disable-next-line */
export const headerLinks = (language = 'en', affiliate = '') => {
  const langPath = language === 'en' ? '' : `/${language}`;

  return {
    home: getLocalizationLink(language, '/'),
    homeJP: 'https://www.liquid.com/ja',
    liquidPlatform: tempLink,
    products: tempLink,

    // lending: `${TRADE_URL}${langPath}/lend/market`,
    margin: getLocalizationLink(language, '/margin-trading/'),
    infinity: getLocalizationLink(language, '/infinity/'),
    company: getLocalizationLink(language, '/company/'),
    fees: getLocalizationLink(language, '/fees/'),
    security: getLocalizationLink(language, '/security/'),
    pro: getLocalizationLink(language, '/pro/'),
    quickExchange: getLocalizationLink(language, '/quick-exchange/'),
    pay: getLocalizationLink(language, '/pay/'),
    referrals: getLocalizationLink(language, '/referrals/'),
    listings: getLocalizationLink(language, '/listings/'),
    marketSearch: getLocalizationLink(language, '/market-prices/'),
    qashBurn: getLocalizationLink(language, '/qash-burn/'),
    minimumOrderSize: getLocalizationLink(language, '/min-order-size/'),

    anchor: `${TRADE_URL}${langPath}/exchange/ANCTUSD?utm_source=rotating%20banner&utm_medium=cpc&utm_campaign=Anchor%20Rotating%20Banner&utm_content=Anchor%20Rotating%20Banner`,
    spotTrade: `${TRADE_URL}${langPath}/exchange`,
    marginTrade: `${TRADE_URL}${langPath}/margin`,
    infinityTrade: `${TRADE_URL}${langPath}/infinity`,
    perpetualTrade: `${TRADE_URL}${langPath}/perpetual`,
    markets: `${TRADE_URL}${langPath}/markets`,
    ieos: `${TRADE_URL}${langPath}/ieo-market`,

    login: `${TRADE_URL}${langPath}/sign-in`,
    getStarted: `${TRADE_URL}${langPath}/sign-up`,
    corporateAccount: `${TRADE_URL}${langPath}/sign-up`,

    academy: 'https://blog.liquid.com/tag/beginner-guide',
    hederaBlog:
      'https://blog.liquid.com/what-is-hedera-hashgraph-the-blockchain-rival',
    hederaLink:
      'https://blog.liquid.com/virtual-rehab-the-blockchain-solution-for-psychological-rehabilitation',
    paymentLicense:
      'https://blog.liquid.com/liquid-account-verification-and-identification-changes',
    support: 'https://help.liquid.com',
    signUp: getLocalizationLink(language, '/sign-up/'),
    buyBitcoin: getLocalizationLink(language, '/buy-bitcoin'),
  };
};

export const chartLink = (language = 'en', symbol = '') => {
  const langPath = language === 'en' ? '' : `/${language}`;
  return `${TRADE_URL}${langPath}/exchange/${symbol}`;
};

export const qexLink = (language = 'en', from, to) => {
  const langPath = language === 'en' ? '' : `/${language}`;
  if (from && to) {
    return `${TRADE_URL}${langPath}/quick-exchange/?to=${to}&from=${from}`;
  }
  return `${TRADE_URL}${langPath}/quick-exchange/`;
};

export const footerLinks = (language = 'en') => {
  const langPath = language === 'en' ? '' : `/${language}`;
  const enData = {
    spot: `${TRADE_URL}${langPath}/exchange`,
    trade: `${TRADE_URL}${langPath}/margin`,
    market: `${TRADE_URL}${langPath}/markets`,
    ieoMarket: `${TRADE_URL}${langPath}/ieo-market`,
    // lending: `${TRADE_URL}${langPath}/lend/market`,

    creditCard: getLocalizationLink(language, '/buy-crypto-with-credit-card/'),

    margin: getLocalizationLink(language, '/margin-trading/'),
    infinity: getLocalizationLink(language, '/infinity/'),
    aboutUs: getLocalizationLink(language, '/company/'),
    fees: getLocalizationLink(language, '/fees/'),
    perpetual: getLocalizationLink(language, '/perpetual/p-btcusd'),
    pro: getLocalizationLink(language, '/pro/'),
    quickExchange: getLocalizationLink(language, '/quick-exchange/'),
    pay: getLocalizationLink(language, '/pay/'),
    referrals: getLocalizationLink(language, '/referrals/'),
    listings: getLocalizationLink(language, '/listings/'),

    'buy-bitcoin': getLocalizationLink(language, '/buy-bitcoin'),
    // 'buy-ethereum': '/buy-ethereum/',
    // 'buy-bitcoin-cash': '/buy-bitcoin-cash/',
    // 'buy-xrp': '/buy-xrp/',
    security: getLocalizationLink(language, '/security/'),

    apiDocs: 'https://developers.liquid.com/',
    apiIntegrationDocs: 'https://docs.partners.liquid.com/',
    widgetDocs:
      'https://docs.partners.liquid.com/widget-integration/js-embedded-widget',
    careers: getLocalizationLink(language, '/careers/'),
    blog: `https://blog.liquid.com${
      language === 'vi' ? '/vi?utm_source=google&utm_campaign=blog_VN' : ''
    }`,
    latestNews: 'https://blog.liquid.com',
    paymentLicense:
      'https://blog.liquid.com/liquid-account-verification-and-identification-changes',

    linkSupport: 'liquid.com/support',
    support: 'https://help.liquid.com',
    infinitySupport: 'https://help.liquid.com/liquid-infinity',
    contactUs: 'mailto:support@quoine.com',
    learnAbout: 'https://quoine.com',
    contactSupport: ZENDESK_GLOBAL,
    referralsRules:
      'https://help.liquid.com/en/articles/2397941-liquid-referral-program-terms-conditions',

    termOfUse:
      'https://quoine-prod.s3.amazonaws.com/uploads/policy_document/term_document/249/Liquid_Terms_of_Use__Quoine_Pte._Ltd.___2020.07.31_.pdf',
    privacyPolicy:
      'https://quoine-prod.s3.amazonaws.com/uploads/policy_document/term_document/116/Liquid_Privacy_Policy_and_Cookie_Policy__Global__v2.00__Final_2019.03.06_.pdf',
    tradingRules:
      'https://quoine-prod.s3.amazonaws.com/uploads/policy_document/term_document/248/Liquid_Trading_Rules__Quoine_Pte._Ltd.___2020.07.31_.pdf',
    riskDisclosure:
      'https://quoine-prod.s3.amazonaws.com/uploads/policy_document/term_document/118/Liquid_Risk_Disclosure_Statement__Global__v2.00__2019.03.06_Final_.pdf',

    antisocialForces:
      'https://s3-ap-northeast-1.amazonaws.com/quoine-documents/antisocial_forces/%E5%8F%8D%E7%A4%BE%E4%BC%9A%E7%9A%84%E5%8B%A2%E5%8A%9B%E3%81%AB%E3%82%88%E3%82%8B%E8%A2%AB%E5%AE%B3%E3%81%AE%E9%98%B2%E6%AD%A2%E3%81%AB%E9%96%A2%E3%81%99%E3%82%8B%E5%9F%BA%E6%9C%AC%E6%96%B9%E9%87%9D.pdf',
    codeOfConduct:
      'https://s3-ap-northeast-1.amazonaws.com/quoine-documents/code_of_conduct/%E5%80%AB%E7%90%86%E3%82%B3%E3%83%BC%E3%83%88%E3%82%99.pdf',
    status: 'https://status.liquid.com/',
    contactUsForm: 'https://be.liquid.com/contact-team',
  };

  return enData;
};

export const hubspotForm = () => ({
  corporateSignup: 'https://be.liquid.com/corporate-signup',
  usContact: 'https://be.liquid.com/us-contact-form',
  listings: 'https://be.liquid.com/listing_application',
});

export const socialLinks = () => ({
  telegram: 'https://t.me/QUOINENews',
  twitter: 'https://twitter.com/liquid_global',
  facebook: 'https://www.facebook.com/LiquidGlobal',
  youtube: 'https://www.youtube.com/channel/UCOR2GJnFoOgTazC5v6mBTSA',
  instagram: 'https://www.instagram.com/liquid_global',
  linkedin: 'https://www.linkedin.com/company/liquidglobal',
  reddit: 'https://reddit.com/r/Liquid',
});



// WEBPACK FOOTER //
// ../src/constants/links.js